import Reveal from "@/components/Reveal";

const CHAPTERS = [
  {
    n: "01",
    tag: "ORIGIN",
    title: "From a small shop to a brand.",
    body: "Konattu Group began its journey as a small home appliances shop, striving and achieving several goals of success to become a recognized brand in the market.",
  },
  {
    n: "02",
    tag: "GROWTH",
    title: "A foremost name in Kerala retail.",
    body: "Set up in 1998, our chain of shops has become a foremost name in the wholesale and retail community, spanning home appliances, furniture, kitchen appliances and crockery from national and international brands.",
  },
  {
    n: "03",
    tag: "PROMISE",
    title: "Quality products, better service.",
    body: "Our innate forethought to study and identify consumer needs, offering well branded products at reasonable rates with better service, made us one of Kerala's leading branded home appliance dealers.",
  },
];

export const Manifesto = () => (
  <section id="about" className="bg-konattu-cream py-24 md:py-36" data-testid="manifesto-section">
    <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
      <Reveal>
        <span className="font-mono text-xs tracking-[0.35em] text-konattu-red">/ OUR STORY</span>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 mb-20 font-display font-bold text-konattu-charcoal tracking-tight leading-[0.95] text-4xl md:text-6xl max-w-4xl">
          Since 1998, your quality shopping partner.
        </h2>
      </Reveal>

      <div className="flex flex-col divide-y divide-konattu-charcoal/15">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.08}>
            <div className="grid md:grid-cols-12 gap-6 md:gap-10 py-12 group">
              <div className="md:col-span-3 flex items-start gap-4">
                <span className="font-mono text-konattu-red text-sm pt-2">{c.n}</span>
                <span className="font-mono text-xs tracking-[0.3em] text-konattu-charcoal/50 pt-2.5">{c.tag}</span>
              </div>
              <h3 className="md:col-span-4 font-display font-semibold text-2xl md:text-3xl text-konattu-charcoal tracking-tight leading-tight group-hover:text-konattu-red transition-colors duration-500">
                {c.title}
              </h3>
              <p className="md:col-span-5 font-body text-konattu-charcoal/70 text-base md:text-lg leading-relaxed">
                {c.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
